import Openable from 'utils/lib/openable';

class Dropdown extends Openable {
  constructor(element: string | HTMLElement, useOverlay = true) {
    super(element, useOverlay);

    this.classes = {
      active: 'dropdown--active',
    };
  }
}

export default (element: string | HTMLElement, useOverlay = true): Dropdown => (
  new Dropdown(element, useOverlay)
);
